export default __webpack_public_path__ + "static/1-borrow-money-15e3864d6b9752b079eb45153af0383c.jpg";